import React from 'react';
import { TextItem } from './TextItem';
interface DateMapData {
    text: JSX.Element;
    url: string;
    ariaLabel: string;
}

interface BrowseByDateMapProps {
    location_slug: string;
    language_code: string;
}

export const BrowseByDateMap = ({
    location_slug,
    language_code,
}: BrowseByDateMapProps): DateMapData[] => {
    return [
        {
            text: <TextItem date={'Today'} language_code={language_code} />,
            url: `/d/${location_slug}/events--today/`,
            ariaLabel: 'Events Today',
        },
        {
            text: <TextItem date={'Tomorrow'} language_code={language_code} />,
            url: `/d/${location_slug}/events--tomorrow/`,
            ariaLabel: 'Events Tomorrow',
        },
        {
            text: (
                <TextItem date={'This Weekend'} language_code={language_code} />
            ),
            url: `/d/${location_slug}/events--this-weekend/`,
            ariaLabel: 'Events This Weekend',
        },
        {
            text: <TextItem date={'This Week'} language_code={language_code} />,
            url: `/d/${location_slug}/events--this-week/`,
            ariaLabel: 'Events This Week',
        },
        {
            text: <TextItem date={'Next Week'} language_code={language_code} />,
            url: `/d/${location_slug}/events--next-week/`,
            ariaLabel: 'Events Next Week',
        },
        {
            text: (
                <TextItem date={'This Month'} language_code={language_code} />
            ),
            url: `/d/${location_slug}/events--this-month/`,
            ariaLabel: 'Events This Month',
        },
        {
            text: (
                <TextItem date={'Next Month'} language_code={language_code} />
            ),
            url: `/d/${location_slug}/events--next-month/`,
            ariaLabel: 'Events Next Month',
        },
    ];
};
